export default {"src":"https://js-static.hirist.tech/production/8.9.0/_next/static/media/dot.eb2fa8db.svg","height":4,"width":4,"blurWidth":0,"blurHeight":0};